import { Swiper, Navigation } from 'swiper';

class OffsetCards {
  constructor() {
    this.offsetCardsTriple = document.querySelectorAll('.offset-cards__items--3');
    this.offsetCardsTitleClass = '.offset-cards__item-title';
    this.titleMaxHeight = 0;
  }

  init = () => {
    this.initSlider();
    this.listeners();
  };

  listeners = () => {
    window.addEventListener('resize', () => {
      setTimeout(() => {
        this.alignItemsBasedOnTitle();
      }, 10);
    });
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        this.alignItemsBasedOnTitle();
      }, 100);
    });
  };

  initSlider = () => {
    if (!this.offsetCardsTriple) {
      return;
    }

    this.offsetCardsTriple.forEach((e) => {
      const sliderWrapper = e.closest('.offset-cards');
      const prevEl = sliderWrapper.querySelector('.c-arrow--left');
      const nextEl = sliderWrapper.querySelector('.c-arrow--right');

      // eslint-disable-next-line no-new
      new Swiper(e, {
        spaceBetween: 8,
        slidesPerView: 1.3,
        modules: [Navigation],
        navigation: {
          prevEl,
          nextEl,
          disabledClass: 'c-arrow--disabled',
        },
        breakpoints: {
          992: {
            enabled: false,
          },
        },
      });
    });
  };

  alignItemsBasedOnTitle = () => {
    const offsetCardsItemWrappers = document.querySelectorAll('.offset-cards__items');

    offsetCardsItemWrappers.forEach((offsetCardsItemWrapper) => {
      this.titleMaxHeight = 0;
      const offsetCardsItems = offsetCardsItemWrapper.querySelectorAll('.offset-cards__item');
      this.getMaxHeight(offsetCardsItems);

      if (this.titleMaxHeight) {
        this.setMaxHeight(offsetCardsItems);
      }
    });
  };

  setMaxHeight = (offsetCardsItems) => {
    if (this.titleMaxHeight) {
      offsetCardsItems.forEach((element) => {
        const title = element.querySelector(this.offsetCardsTitleClass);
        // eslint-disable-next-line no-param-reassign
        window.setTimeout(() => {
          title.style.height = `${this.titleMaxHeight}px`;
        });
      });
    }
  };

  getMaxHeight = (offsetCards) => {
    offsetCards.forEach((element) => {
      const title = element.querySelector(this.offsetCardsTitleClass);
      title.style.height = 'auto';
      console.log(title.clientHeight);

      if (title.clientHeight > this.titleMaxHeight) {
        this.titleMaxHeight = title.clientHeight;
      }
    });
  };
}

const offsetCardsObject = new OffsetCards();
offsetCardsObject.init();
